import "./index.css";

const NoteLockLoader = () => (
  <div className="not-lock-loader-container">
    <img
      src="https://res.cloudinary.com/daxizvsge/image/upload/v1718606290/IMG_4859_d12m9v.jpg"
      className="note-lock-loader-img"
      alt="note-lock-loader"
    />
  </div>
);

export default NoteLockLoader;
